import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { getVendors } from "api/vendor";
import BaseTable from "components/DataTable/BaseTable";
import ListingImageCol from "components/ListingImageCol";
import MDTypography from "components/MDTypography";
import VendorCategorySelector from "components/VendorCategorySelector";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { formatDateTime } from "utils/helper";

const TABLE_COLUMNS = [
    { id: "name", Header: "Name", accessor: "name", align: "left", sortable: true },
    { id: "category", Header: "Category", accessor: "category", align: "left" },
    { id: "contacts", Header: "Contacts", accessor: "contacts", align: "left" },
    { id: "is_parts_supplier", Header: "Part Supplier", accessor: "part_supplier", align: "left" },
    { id: "hourly_rate", Header: "Hourly Rate", accessor: "hourly_rate", align: "left" },
    { id: "created_at", Header: "Created At", accessor: "created_at", align: "left", sortable: true },
];

export const parentRoute = '/vendors';

const PARTS_SUPPLIER = [
    { value: '', label: "All" },
    { value: true, label: "Yes" },
    { value: false, label: "No" },
];

const VENDOR_FILTER_CONFIGS = [
    {
        id: 'category',
        label: 'Category',
        type: 'custom',
        render: ({ value, onChange }) => (
            <VendorCategorySelector
                label="Vendor Category"
                value={value}
                onChange={(selectedValue) => onChange(selectedValue)}
            />
        ),
    },
    {
        id: 'hourly_rate',
        label: 'Hourly Rate',
        type: 'numberRange',
        minLabel: 'Min',
        maxLabel: 'Max',
    },
    {
        id: 'is_parts_supplier',
        label: 'Parts Supplier',
        type: 'select',
        options: PARTS_SUPPLIER,
        placeholder: 'Parts Supplier',
    },
];

function VendorTable() {
    const navigate = useNavigate();
    const location = useLocation();
    const [refreshKey] = useState(0);
    const savedState = location.state || { sort: "created_at", dir: "desc" };

    const createTableRow = useCallback((item) => ({
        name: <ListingImageCol imgUrl={item.img_url} name={item.name} />,
        category: <MDTypography component="div" variant="standard" color="text">{item.category ?? "-"}</MDTypography>,
        contacts: <MDTypography component="div" variant="standard" color="text">
            {item.contacts?.find(c => c.is_primary)?.name ?? "-"}<br />
            {item.contacts?.find(c => c.is_primary)?.phone ?? "-"}
        </MDTypography>,
        part_supplier: <MDTypography component="div" variant="standard" color="text">
            {item.is_parts_supplier ? 'Yes' : 'No'}
        </MDTypography>,
        hourly_rate: <MDTypography component="div" variant="standard" color="text">
            {item.hourly_rate ?? "-"}
        </MDTypography>,
        created_at: <MDTypography component="div" variant="standard" color="text">
            {formatDateTime(item.created_at)}
        </MDTypography>,
    }), []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <BaseTable
                key={refreshKey}
                queryKey={["vendors"]}
                title="Vendors Management"
                columns={TABLE_COLUMNS}
                fetchData={getVendors}
                filterConfigs={VENDOR_FILTER_CONFIGS}
                defaultState={savedState}
                createTableRow={createTableRow}
                showAddButton
                addButtonText="Add Vendors"
                onAddClick={() => navigate(`${parentRoute}/add-vendor`, { state: savedState })}
                showSearch
                searchPlaceholder="Search vendor name..."
                onClickRow={(row, key) => { navigate(`${parentRoute}/${row.id}`, { state: savedState }) }}
            />
        </DashboardLayout>
    );
}

export default VendorTable;
